@if (!_addAddress) {
<div class="row" [@collapse]>
  <button class="button-base rounded-full" (click)="toggleAddAddress()">{{'address.add_address'| translate}}</button>
</div>
}
@if (_addAddress) {
<div class="block " [@collapse] [formGroup]="customerAddressForm" id="addressform">
  <div class="flex flex-col px-2 rounded-lg max-w-[500px]">
    <div class="flex flex-row justify-between">
      <strong class="">{{'address.add_address'| translate}}</strong>
      <button class="" (click)="toggleAddAddress()">{{'common.cancel_button'| translate}}</button>
    </div>
    @if (showdescription) {
    <div class="form-field m-0">
      <label>{{'address.name' | translate}}</label>
      <input formControlName="name" id="addressname" [ngClass]="colorscheme" name="addressname" placeholder="{{'address.name' | translate}}" required type="text">
      @if (hasError('name', 'required')) {
      <span class="error" [@collapse]>{{'validation.required' | translate}}</span>
      }
    </div>
    }
    <ng-container formGroupName="address">
      <div class="form-field ">
        <label>{{'address.i_live_in' | translate}}</label>
        <select formControlName="countrycode" [ngClass]="colorscheme" id="" type="text">
          <!-- default option for ios 15 to select as default, otherwise the validation will not work -->
          @if (!customerAddressForm.get('address.countrycode').value) {<option [value]="null" disabled="true"> {{'address.i_live_in' | translate}} </option>}
          @for (code of customercountries; track code) {
          <option [value]="code">
            {{'countrycode.' + code |translate}}
          </option>
          }
        </select>
      </div>
      <div class="flex flex-wrap justify-between gx-1 max-w-[500px]">
        <div class="form-field w-2/5">
          <label>{{'address.postalcode' | translate}}</label>
          <input formControlName="postalcode" [ngClass]="colorscheme" id="postalcode" name="postalcode" placeholder="{{'address.postalcode' | translate}}" required
            type="text">
          @if (hasError('address.postalcode', 'required')) {
          <span class="error" [@collapse]>{{'validation.required' | translate}}</span>
          }
          @if (hasError('address.postalcode', 'pattern')) {
          <span class="error" [@collapse]>{{'validation.invalid_postalcode' | translate}}</span>
          }
          @if (hasError('address.postalcode', 'maxlength')) {
          <span class="error" [@collapse]>{{'validation.maxlength_value' | translate: {value:20} }}</span>
          }
        </div>
        <div class="form-field w-1/4 ">
          <label class="whitespace-nowrap">{{'address.number' | translate}}</label>
          <input formControlName="number" [ngClass]="colorscheme" id="number" name="number" placeholder="{{'address.number' | translate}}" required type="number">
          @if (hasError('address.number', 'required')) {
          <span class="error whitespace-nowrap" [@collapse]>{{'validation.required' | translate}}</span>
          }
        </div>
        <div class="form-field w-1/4 ">
          <label>{{'address.addition_abbr' | translate}}</label>
          <input formControlName="addition" [ngClass]="colorscheme" id="addition" name="addition" placeholder="{{'address.addition_abbr' | translate}}" type="text">
          @if (hasError('address.addition', 'maxlength')) {
          <span class="error" [@collapse]>{{'validation.maxlength_value' | translate: {value:20} }}</span>
          }
        </div>
      </div>
      @if (customerAddressForm.get('address').valid && !showFullAddress && customerAddressForm.get('address').get('countrycode').value === 'NL') {
      <small [@collapse] class="col-12 mx-2 mb-2 d-block addresslabel">
        {{customerAddressForm.get('address').get('street').value}} {{customerAddressForm.get('address').get('number').value}}@if
        (customerAddressForm.get('address').get('addition').value) {
        <span>-{{customerAddressForm.get('address').get('addition').value}}</span>
        }, {{customerAddressForm.get('address').get('postalcode').value}} {{customerAddressForm.get('address').get('city').value}}
      </small>
      }
      @if (showFullAddress || customerAddressForm.get('address').get('countrycode').value !== 'NL') {
      <div [@collapse] class="row g-2">
        <div class="row">
          <div class="form-field ">
            <label>{{'address.street' | translate}}</label>
            <input formControlName="street" [ngClass]="colorscheme" id="street" name="street" placeholder="{{'address.street' | translate}}" required type="text">
            @if (hasError('address.street', 'maxlength')) {
            <span class="error" [@collapse]>{{'validation.maxlength_value' | translate: {value:100} }}</span>
            }
            @if (hasError('address.street', 'required')) {
            <span class="error" [@collapse]>{{'validation.required' | translate}}</span>
            }
          </div>
        </div>
        <div class="form-field">
          <label>{{'address.city' | translate}}</label>
          <input formControlName="city" [ngClass]="colorscheme" id="city" name="city" placeholder="{{'address.city' | translate}}" required type="text">
          @if (hasError('address.city', 'maxlength')) {
          <span class="error" [@collapse]>{{'validation.maxlength_value' | translate: {value:100} }}</span>
          }
          @if (hasError('address.city', 'required')) {
          <span class="error" [@collapse]>{{'validation.required' | translate}}</span>
          }
        </div>
      </div>
      }
    </ng-container>
  </div>
</div>
}